module.exports = __webpack_public_path__ + "static/media/Technologyicon01@3x.66ab8b85.png";